import { TrackingProductModel } from "@omni/types/components/tracking/models/trackingProduct.model";
import { ProductImpressionTrackingInfo } from "@omni/types/components/tracking/tracking-info/impression/productImpression.trackingInfo";

export interface GoogleAnalyticsProduct {
    name: string;
    category?: string;
    id: string;
    price: number;
    discount?: number | string;
    tax: string;
    currencyCode: string;
    variant?: string;
    brand: string;
    ean?: string | null;

    // in a list:
    list?: string;
    listTitle?: string;
    placement?: number;

    // in cart
    quantity?: number;
}

const getGoogleAnalyticsProduct = (
    product: ProductImpressionTrackingInfo | TrackingProductModel
): GoogleAnalyticsProduct => {
    return {
        name: product.name,
        category: product.category,
        id: product.id,
        ean: product.ean,
        price: product.unitPrice,
        discount: product.reduction,
        currencyCode: product.currencyCode,
        tax: product.tax,
        brand: product.brand,
        ...("list" in product && { list: product.list }),
        ...("listTitle" in product && { listTitle: product.listTitle }),
        ...("placement" in product && { placement: product.placement })
    };
};

export { getGoogleAnalyticsProduct };
